<template>
  <div class="UXcheckboxGroup">
    <p>
      <v-checkbox
        :disabled="statusDisabled"
        @change="updateStatusOption"
        v-model="statusSelected"
        value="ACTIVE"
        label="有効"
        class="UXcheckbox gray"
        hide-details
      ></v-checkbox>
    </p>
    <p>
      <v-checkbox
        :disabled="statusDisabled"
        @change="updateStatusOption"
        v-model="statusSelected"
        value="INACTIVE"
        label="無効"
        class="UXcheckbox gray"
        hide-details
      ></v-checkbox>
    </p>
    <p>
      <v-checkbox
        :disabled="statusDisabled"
        @change="updateStatusOption"
        v-model="statusSelected"
        value="RESOLVED"
        label="解決"
        class="UXcheckbox gray"
        hide-details
      ></v-checkbox>
    </p>
    <p>
      <v-checkbox
        :disabled="statusDisabled"
        @change="updateStatusOption"
        v-model="statusSelected"
        value="PENDING"
        label="保留"
        class="UXcheckbox gray"
        hide-details
      ></v-checkbox>
    </p>
  </div>
</template>

<script>
import TicketListUtil from '../../../util/ticket_list_util'
import OptionType from '../../../enums/ticketListOptionType'

export default {
  props: {
    updateOption: Function,
    disableOption: {
      type: String,
      default: ''
    },
    pageType: String
  },
  data: () => ({
    tipDialog: false,
    selected: [],
    templates: [],
    pagination: {},
    incomingSelected: [],
    statusSelected: [],
    prioritySelected: [],
    statusDisabled: false
  }),
  components: {},
  methods: {
    updateStatusOption () {
      this.updateOption('status', this.statusSelected.length === 0 ? [] : this.statusSelected)
    },
    resetAll () {
      this.incomingSelected = []
      this.statusSelected = this.disableOption === 'status' ? ['RESOLVED'] : ['ACTIVE', 'INACTIVE', 'RESOLVED', 'PENDING']
      this.prioritySelected = []
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },
  created () {
    this.pagination.rowsPerPage = 12
  },
  mounted () {
    this.incomingSelected = TicketListUtil.parseJsonIntoOption(this.pageType, OptionType.INCOME, localStorage.getItem('TICKET_LIST_OPTION'))
    this.statusSelected = TicketListUtil.parseJsonIntoOption(this.pageType, OptionType.STATUS, localStorage.getItem('TICKET_LIST_OPTION'))
    this.prioritySelected = TicketListUtil.parseJsonIntoOption(this.pageType, OptionType.PRIORITY, localStorage.getItem('TICKET_LIST_OPTION'))

    if (this.statusSelected.length === 0) {
      this.statusSelected = ['ACTIVE', 'INACTIVE', 'RESOLVED', 'PENDING']
    }

    if (this.disableOption === 'status') {
      this.statusDisabled = true
      this.statusSelected = ['RESOLVED']
      this.updateStatusOption()
    }
  }
}
</script>
<style>
  @import url("../../css/ticket_management.css");
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/layout/ticket_check_status.vue